import { IQuestionsGroupProps } from 'app/components/questions/base'
import { SSABenefits } from 'app/containers/PipelineSection/SSA/Benefits'
import { SSAIntro } from 'app/containers/PipelineSection/SSA/Introduction'
import { SSAOptimizeQuestionsGroup } from 'app/containers/PipelineSection/SSA/Optimize'
import { SSAGPOReduction } from './ReductionGPO'
import { SSAReductionWEP } from './ReductionWEP'

interface ISSAQuestionGroups {
  SSABenefits: () => React.ReactElement<IQuestionsGroupProps>
  SSAIntro: () => React.ReactElement<IQuestionsGroupProps>
  SSAReductionWEP: () => React.ReactElement<IQuestionsGroupProps>
  SSAGPOReduction: () => React.ReactElement<IQuestionsGroupProps>
  SSAOptimizeQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
}

const SSAQuestionGroups: ISSAQuestionGroups = {
  SSABenefits,
  SSAIntro,
  SSAReductionWEP,
  SSAGPOReduction,
  SSAOptimizeQuestionsGroup,
}

type SSAQuestionGroupsKeys = keyof ISSAQuestionGroups

export {
  ISSAQuestionGroups,
  SSAQuestionGroups,
  SSAQuestionGroupsKeys,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/SSA/index.tsx